if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.petstifyButtonDefaultText = this.submitButtonText ? this.submitButtonText.textContent : '';

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.petstifyAddedToCart = false;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker =
              typeof CartPerformance !== 'undefined' && CartPerformance.createStartingMarker
                ? CartPerformance.createStartingMarker('add:wait-for-subscribers')
                : null;
            if (!this.error && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined')
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                if (typeof CartPerformance !== 'undefined' && CartPerformance.measureFromMarker && startMarker) {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                }
              });
            this.error = false;
            this.petstifyAddedToCart = true;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.petstifyMeasure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                    this.showPetstifyAddedMessage();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.petstifyMeasure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
              this.showPetstifyAddedMessage();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            if (this.petstifyAddedToCart) this.flashPetstifyAddedButton();
            if (typeof CartPerformance !== 'undefined' && CartPerformance.measureFromEvent) {
              CartPerformance.measureFromEvent("add:user-action", evt);
            }
          });
      }

      petstifyMeasure(name, callback) {
        if (typeof CartPerformance !== 'undefined' && CartPerformance.measure) {
          CartPerformance.measure(name, callback);
          return;
        }
        callback();
      }

      showPetstifyAddedMessage() {
        let toast = document.querySelector('[data-petstify-cart-toast]');
        if (!toast) {
          toast = document.createElement('div');
          toast.setAttribute('data-petstify-cart-toast', '');
          toast.className = 'petstify-cart-toast';
          toast.setAttribute('role', 'status');
          toast.setAttribute('aria-live', 'polite');
          document.body.appendChild(toast);
        }

        toast.innerHTML = '<strong>Added to cart</strong><span>Your Petstify clock is waiting in the cart.</span><a href="/cart">View cart</a>';
        toast.classList.add('is-visible');
        window.clearTimeout(this.petstifyToastTimer);
        this.petstifyToastTimer = window.setTimeout(() => {
          toast.classList.remove('is-visible');
        }, 4200);
      }

      flashPetstifyAddedButton() {
        if (!this.submitButtonText) return;

        const originalText = this.petstifyButtonDefaultText || window.variantStrings.addToCart;
        this.submitButtonText.textContent = 'Added to cart';
        window.clearTimeout(this.petstifyButtonTimer);
        this.petstifyButtonTimer = window.setTimeout(() => {
          this.submitButtonText.textContent = originalText;
        }, 1800);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
